export enum HighlightInteractionEvent {
  HIGHLIGHT_INTERACTED = "highlight-interacted",
  HIGHLIGHT_ADDED = "highlight-added",
  CLOSE_BUBBLE_MENU = "close-bubble-menu",
  COPY_TO_CLIPBOARD = "copy-to-clipboard",
}

export interface HighlightInteractedEvent extends CustomEvent<{ group: string }> {
  type: HighlightInteractionEvent.HIGHLIGHT_INTERACTED;
  detail: {
    group: string;
  };
}

export function isHighlightInteractedEvent(event: Event): event is HighlightInteractedEvent {
  return event.type === HighlightInteractionEvent.HIGHLIGHT_INTERACTED;
}

export interface HighlightAddedEvent extends CustomEvent<{ group: string }> {
  type: HighlightInteractionEvent.HIGHLIGHT_ADDED;
  detail: {
    group: string;
  };
}

export function isHighlightAddedEvent(event: Event): event is HighlightAddedEvent {
  return event.type === HighlightInteractionEvent.HIGHLIGHT_ADDED;
}

export interface CopyToClipboardEvent extends CustomEvent<{ group: string }> {
  type: HighlightInteractionEvent.COPY_TO_CLIPBOARD;
  detail: {
    group: string;
  };
}

export function isCopyToClipboardEvent(event: Event): event is CopyToClipboardEvent {
  return event.type === HighlightInteractionEvent.COPY_TO_CLIPBOARD;
}
